export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export const validatePassword = (password: string): PasswordValidationResult => {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push('password.error.minLength');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('password.error.uppercase');
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push('password.error.number');
  }
  
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('password.error.symbol');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};
